import { HttpService, TokenService } from "../utils";
import { AnalyticsService } from "../EventAnalytics/AnalyticsService";

const tokenService = new TokenService("acciojobs-token");
const httpService = new HttpService(tokenService);
const analyticsService = new AnalyticsService(httpService);

export interface Services {
  tokenService: TokenService;
  httpService: HttpService;
  analyticsService: AnalyticsService;
}

export const services = {
  httpService,
  analyticsService,
};
